import { Component, ViewChild, Input } from "@angular/core";
import { AppComponent } from "src/app/app.component";
import { IMyDateModel, IAngularMyDpOptions } from 'angular-mydatepicker';
import { Globals } from "src/app/globals";
import { AuthService } from "src/app//API/auth.service";
import { DMApiService } from "src/app/API/dmapi.service";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl
} from "@angular/platform-browser";
import { NgForm } from "@angular/forms";
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  Validators
} from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ImageViewerDialog } from "../ImageViewerDialog/ImageViewerDialog";
import { ScrollHelper } from "../../Helper/ScrollHelper";
import { DisableControlDirective } from "../DisableControlDirective";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { PMNotesComponent } from "../PMNotesComponent/PMNotesComponent";
import { PMPartsComponent } from "../PMPartsControl/PMPartsComponent";
import {
  PMNotesModel,
  PMPartsModel
} from "src/app/Core/Shared/PMNotesComponent/PMNotesModel";
import { ConfirmationDialog } from "src/app/Core/ConfirmationDialog";
import { DMRepairCustomValidators } from "src/app/Validator/EuipmentRepairStatus";
import { CommonCustomValidators } from "src/app/Validator/CommonValidator";
import { DMPMCustomValidators } from "src/app/Validator/PMValidator";
import { DatePipe, CurrencyPipe } from "@angular/common";
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { PartsComponent } from "../PartsControl/PartsComponent";

@Component({
  selector: "PreventiveMaintenanceCommonDetail",
  templateUrl: "./PreventiveMaintenanceCommonDetail.component.html",
  styleUrls: ["./PreventiveMaintenanceCommonDetail.css"]
})
export class PreventiveMaintenanceCommonDetailComponent {
  // innerContent = '<div ><div >    <div class="box-header" style="border-bottom: 1px solid black;">      <h3 class="box-title">Notes</h3>    </div>    <div class="box-body">      <div class="row ng-star-inserted">        <div class="col-sm-12 box-row">          <div class="col-sm-2 text-center"><strong>Date</strong></div>          <div class="col-sm-1 text-center"><strong>User</strong></div>          <div class="col-sm-1 text-center"><strong>Note</strong></div>                  </div>      </div>      <div class="col-sm-12 box-row" <div class="col-sm-12 box-row">        <div class="col-sm-2 text-center ng-star-inserted"> 25/08/2019 09:29 </div>        <div class="col-sm-1 text-center"> Admin </div>        <div class="col-sm-5 text-left"> O-RING 13MM ID X 1.5MM </div>              </div>      <div class="col-sm-12 box-row" <div class="col-sm-12 box-row">          <div class="col-sm-2 text-center ng-star-inserted"> 25/08/2019 09:29 </div>          <div class="col-sm-1 text-center"> Admin </div>          <div class="col-sm-5 text-left"> O-RING 13MM ID X 1.5MM </div>                  </div>    </div>  </div><div>  <div class="box-header" style="border-bottom: 1px solid black;">    <h3 class="box-title">Replaced Part</h3>  </div>  <div class="box-body">    <div class="row ng-star-inserted">      <div class="col-sm-12 box-row">        <div class="col-sm-2 text-center"><strong>Date</strong></div>        <div class="col-sm-1 text-center"><strong>User</strong></div>        <div class="col-sm-1 text-center"><strong>Part ID</strong></div>        <div class="col-sm-5 text-center"><strong>Part Description</strong></div>        <div class="col-sm-1 text-center"><strong>Part Qty.</strong></div>        <div class="col-sm-1 text-center"><strong>Part Cost</strong></div>      </div>    </div>       <div class="col-sm-12 box-row">      <div class="col-sm-2 text-center ng-star-inserted"> 25/08/2019 09:29 </div>      <div class="col-sm-1 text-center"> Admin </div>      <div class="col-sm-1 text-center"> 579092 </div>      <div class="col-sm-5 text-left"> O-RING 13MM ID X 1.5MM </div>      <div class="col-sm-1 text-center"> 1 </div>      <div class="col-sm-1 text-right"> $1.10 </div>    </div>    <div class="col-sm-12 box-row">      <div class="col-sm-2 text-center ng-star-inserted"> 25/08/2019 09:29 </div>      <div class="col-sm-1 text-center"> Admin </div>      <div class="col-sm-1 text-center"> 579092 </div>      <div class="col-sm-5 text-left"> O-RING 13MM ID X 1.5MM </div>      <div class="col-sm-1 text-center"> 1 </div>      <div class="col-sm-1 text-right"> $1.10 </div>    </div>    <div class="col-sm-12 box-row">      <div class="col-sm-2 text-center ng-star-inserted"> 25/08/2019 09:29 </div>      <div class="col-sm-1 text-center"> Admin </div>      <div class="col-sm-1 text-center"> 579092 </div>      <div class="col-sm-5 text-left"> O-RING 13MM ID X 1.5MM </div>      <div class="col-sm-1 text-center"> 1 </div>      <div class="col-sm-1 text-right"> $1.10 </div>    </div>  </div></div></div>';
  popleft = 0;
  poptop = 0;
  currentQuestionId = "0";

  @Input() detailsType = "";
  @Input() title = "2008K@Home Preventive Maintenance Details";
  @Input() ListURL = "Home/PreventiveMaintenanceSearch";
  @Input() headerText = "Preventive Maintenance";
  showSection = false;
  private today = new Date();
  dialogRef: MatDialogRef<ConfirmationDialog>;

  @ViewChild(PMNotesComponent, { static: true })
  notes: PMNotesComponent;
   @ViewChild(PartsComponent, { static: false })
  parts: PartsComponent;
 


  imgURL = "/assets/img/PM_Images/Sec 7.2.3.png";
  zoomMode = "click";
  private scrollHelper: ScrollHelper = new ScrollHelper();
  submitted = false;
  submittedOut = false;
  btnShowMainList = true;
  // ListURL = "/DialysisMachine/PreventiveMaintenanceSearch";
  btnShowSearch = false;
  blnshowDelete = false;
  transactionStatus: boolean = true;
  DivisionList = [];
  Equipments = [];
  currentUser = this.authentication.GetUserFirstName();
  currentUserId = this.authentication.GetUserId();
  createdBy = this.authentication.GetUserId();
  modifiedBy = this.authentication.GetUserId();
  userDesignation = this.authentication.GetDesignationName();
  partscategoryname = "Dialysis Machines";
  items: UntypedFormArray;
  selectedEquipmentHours = 0;
  insurfacedisOptions = [
    { value: "", text: "Select" },
    { value: "CaviWipes XL", text: "CaviWipes XL"},
    { value: "Virox", text: "Virox" },
    { value: "N/A", text: "N/A" }
  ];

  YesNoOptions = [
    { name: 'Yes' },
    { name: 'No' }
  ]

  OptionSelectedValue = ['Yes'];

  SubTypeList = [
    { value: "", text: "Select" },
    { value: "QUARTERLY", text: "QUARTERLY", type:"2008K" },
    { value: "4000 Hrs ANNUAL PM", text: "4000 Hrs ANNUAL PM", type:"2008K" },
    { value: "12 Months", text: "12 Months", type:"DBB-EXA" },
    { value: "24 Months", text: "24 Months", type:"DBB-EXA" },
    { value: "6000 Hours", text: "6000 Hours", type:"DBB-EXA" },
    { value: "12000 Hours", text: "12000 Hours", type:"DBB-EXA" },

  ];

  // inhydraulicdisOptions = [
  //   { value: "", text: "Select" },
  //   { value: "Heat", text: "Heat" },
  //   { value: "Heat Citric", text: "Heat Citric" },
  //   { value: "Chemical", text: "Chemical" },
  //   { value: "No", text: "No" }
  // ];

  inhydraulicdisOptions = [
      { value: '', text: 'Select' },
      { value: 'Degreasing', text: 'Degreasing' },
      { value: 'Heat Cleaned', text: 'Heat Cleaned' },
      {value: 'N/A', text: 'N/A'}
  ];

  autoPartsDetails = [];

  selectedDivisionObj;
  selectedDivisionsText;
  selectedEquipmentText;
  selectedEquipmentObj;
  isAutoPart;

  preventativeMaintenanceForm = new UntypedFormGroup({
    Id: new UntypedFormControl(0),
    type: new UntypedFormControl(''),
    subtype: new UntypedFormControl('', Validators.required),
    machineName: new UntypedFormControl("Fresenius 5008"),
    PMCode: new UntypedFormControl(""),
    divisionId: new UntypedFormControl("", Validators.required),
    equipmentId: new UntypedFormControl("", Validators.required),
    dateIn: new UntypedFormControl("", Validators.required),
    hoursIn: new UntypedFormControl("", [
      Validators.required,
      Validators.pattern(Globals.NumberNumericRegexWithoutZero)
    ]),
    inHydraulicDisinfection: new UntypedFormControl("", Validators.required),
    inSurfaceDisinfection: new UntypedFormControl("", Validators.required),
    dateOut: new UntypedFormControl(""),
    hoursOut: new UntypedFormControl(""),
    scheduledPM: new UntypedFormControl(0),
    scheduledPMId: new UntypedFormControl(0),
    outHydraulicDisinfection: new UntypedFormControl(""),
    outSurfaceDisinfection: new UntypedFormControl(""),
    status: new UntypedFormControl(""),
    createdBy: new UntypedFormControl(""),
    createdOn: new UntypedFormControl(""),
    modifiedBy: new UntypedFormControl(""),
    PMUser: new UntypedFormControl(""),
    transactionStatus: new UntypedFormControl(false),
    transactions: new UntypedFormArray([this.createTransactions()])
  });

  btnshowSave = this.f.status.value != "Completed";
  constructor(
    private currencyPipe: CurrencyPipe,
    private authentication: AuthService,
    public globals: Globals,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private dmapi: DMApiService,
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private commonapi: CommonApiService
  ) { }

  // implementation of canDeactivate
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.preventativeMaintenanceForm.dirty && this.submitted == false) {
      this.dialogRef = this.dialog.open(ConfirmationDialog, {
        disableClose: true
      });
      this.dialogRef.componentInstance.confirmMessage =
        "You have unsaved changes! If you leave, your changes will be lost.";
      return this.dialogRef.afterClosed().pipe(
        map((res: any) => {
          // console.log('res', res);
          return res;
        })
      );
    } else return true;
  }

  ngOnInit() {

    this.authentication.GetCurrentDateTimeFromServer().subscribe(currentDate => {
      this.today = new Date(currentDate);
      this.setDateOptions();

      this.scrollHelper.scrollToFirst("logo");
      this.route.queryParams.subscribe(params => {
        this.f.Id.setValue(params["id"] || "0");
        if (this.f.Id.value != "0") {
          this.setDataModel();
        } else {
          this.authentication.GetCurrentUserDivision().subscribe(division => {
            this.setModel(null);
            if (division.length === 1) {
              this.f.divisionId.setValue(division[0]);
              this.DivisionDropDownChanged();
            }
          }, error => {
            AppComponent.addAlert(error.message, 'error');
            AppComponent.HideLoader();
          });
        }

        this.setValidators();
      }, (error) => {
        AppComponent.addAlert(error.message, "error");
        AppComponent.HideLoader();

      });
      AppComponent.HideLoader();
    }, error => {
      AppComponent.HideLoader();
    });
  }

  executeSave(transactionObj?: object) {
    AppComponent.loading = true;
    this.submitted = true;

    if (transactionObj != undefined)
      this.setOutValidations(true);

    if (this.transactionStatus)
      this.submittedOut = true;

    this.f.createdBy.setValue(this.createdBy);
    this.f.modifiedBy.setValue(this.modifiedBy);

    // if (
    //   this.f.dateOut &&
    //   this.f.dateOut.value &&
    //   new Date(
    //     this.f.dateIn.value.date.year,
    //     this.f.dateIn.value.date.month - 1,
    //     this.f.dateIn.value.date.day
    //   ) >
    //   new Date(
    //     this.f.dateOut.value.date.year,
    //     this.f.dateOut.value.date.month - 1,
    //     this.f.dateOut.value.date.day
    //   )
    // )
    if (
          this.f.dateOut?.value &&
          (
            (this.f.dateIn.value?.singleDate?.jsDate && this.f.dateOut.value?.singleDate?.jsDate &&
              new Date(this.f.dateIn.value.singleDate.jsDate) > new Date(this.f.dateOut.value.singleDate.jsDate)) ||

            (this.f.dateIn.value?.date && this.f.dateOut.value?.date &&
              new Date(
                this.f.dateIn.value.date.year,
                this.f.dateIn.value.date.month - 1,
                this.f.dateIn.value.date.day
              ) >
              new Date(
                this.f.dateOut.value.date.year,
                this.f.dateOut.value.date.month - 1,
                this.f.dateOut.value.date.day
              ))
          )
        )
      this.preventativeMaintenanceForm.controls.dateOut.setErrors({
        error: true
      });
    else {
      if (!this.transactionStatus)
        this.preventativeMaintenanceForm.controls.dateOut.setErrors(null);
    }

    if (
      this.f.hoursOut &&
      this.f.hoursOut.value &&
      this.f.hoursOut.value < this.f.hoursIn.value
    )
      this.preventativeMaintenanceForm.controls.hoursOut.setErrors({
        error: true
      });
    else {
      if (!this.transactionStatus)
        this.preventativeMaintenanceForm.controls.hoursOut.setErrors(null);
    }

    if (this.preventativeMaintenanceForm.invalid) {
      AppComponent.addAlert(Globals.FormErrorMessage, "error");
      AppComponent.loading = false;

      this.scrollHelper.scrollToFirst("ng-invalid");
      return;
    }

    var dmPMCreate = this.prepareCreateViewModel();
    if (dmPMCreate.Id == "0") {
      this.dmapi.CreateDMPMDetails(dmPMCreate).subscribe(
        success => {
          this.setModel(success);
          // AppComponent.loading = false;

          if (transactionObj) {
            this.processTransaction(transactionObj);
          }
          AppComponent.addAlert("Data Saved successfully!", "success");
        },
        error => {
          if (
            error &&
            error.error &&
            error.error.returnMessage &&
            error.error.returnMessage[0]
          ) {
            AppComponent.addAlert(error.error.returnMessage[0], "error");
            this.scrollHelper.scrollToFirst("logo");
          } else {
            AppComponent.addAlert(error.message, "error");
            this.scrollHelper.scrollToFirst("logo");
          }

          AppComponent.HideLoader();
        }
      );
    } else {
      this.dmapi.UpdateDMPMDetails(dmPMCreate).subscribe(
        success => {
          this.setModel(success);
          // AppComponent.loading = false;
          AppComponent.addAlert("Data Saved successfully!", "success");
        },
        error => {
          AppComponent.addAlert(error.message, "error");
          AppComponent.HideLoader();
          this.scrollHelper.scrollToFirst("ng-invalid");
        }
      );
    }
  }

  prepareCreateViewModel() {
    const modelCreate = <any>{};
    modelCreate.Id = this.f.Id.value;
    modelCreate.machineName = this.f.machineName.value;
    modelCreate.PMCode = this.f.PMCode.value;
    modelCreate.divisionId = this.f.divisionId.value;
    modelCreate.equipmentId = this.f.equipmentId.value;
    modelCreate.scheduledPM = this.f.scheduledPM.value;
    modelCreate.scheduledPMId =
      this.f.scheduledPMId.value === 0 ? null : this.f.scheduledPMId.value;

    if (this.f.dateIn.value !== null && this.f.dateIn.value !== undefined) {
    //  modelCreate.dateIn = Globals.GetAPIDate(this.f.dateIn.value.jsdate);
      modelCreate.dateIn = Globals.GetAPIDate(this.f.dateIn.value?.jsdate || this.f.dateIn.value?.singleDate?.jsDate);
    }

    modelCreate.hoursIn = this.f.hoursIn.value;
    modelCreate.inHydraulicDisinfection = this.f.inHydraulicDisinfection.value;
    modelCreate.inSurfaceDisinfection = this.f.inSurfaceDisinfection.value;
    modelCreate.dateOut = this.f.dateOut.value;

    if (this.f.dateOut.value !== null && this.f.dateOut.value !== undefined) {
      //modelCreate.dateOut = Globals.GetAPIDate(this.f.dateOut.value.jsdate);
      modelCreate.dateOut = Globals.GetAPIDate(this.f.dateOut.value?.jsdate || this.f.dateOut.value?.singleDate?.jsDate);
    }

    modelCreate.hoursOut = this.f.hoursOut.value;
    modelCreate.outHydraulicDisinfection = this.f.outHydraulicDisinfection.value;
    modelCreate.outSurfaceDisinfection = this.f.outSurfaceDisinfection.value;

    if (
      this.f.dateOut.value &&
      this.f.hoursOut.value &&
      this.f.outHydraulicDisinfection.value != "" &&
      this.f.outSurfaceDisinfection.value != ""
    ) {
      modelCreate.status = "Completed";
    } else {
      modelCreate.status = "In Progress";
    }

    // notes
    modelCreate.notesDetails = this.notes.NoteList;
    // parts
    modelCreate.partsDetails = this.notes.componentDetails.AllParts;

    console.log('All Parts <<<<<<<<<<<'+ this.notes.componentDetails.AllParts);
    console.log('Prev Parts <<<<<<<<<<<'+this.notes.componentDetails.PrevParts);

    modelCreate.createdBy = this.f.createdBy.value;
    modelCreate.createdOn = this.f.createdOn.value ? this.f.createdOn.value : Globals.GetAPIDate(this.today);
    modelCreate.modifiedBy =  this.f.modifiedBy.value;

    modelCreate.subtype = this.f.subtype.value;

    modelCreate.type = this.f.type.value;

    return modelCreate;
  }

  setModel(result) {
    if (result) {
      this.f.Id.setValue(result.id);
      this.f.status.setValue(result.status);
      this.notes.componentDetails.status = result.status;
      this.notes.componentDetails.dateOut = result.dateOut;
      this.getDivisionDetails();
      this.getEquipmentDetails();
    }

    this.addTransactions(this.f.subtype.value).then(() => {
      this.fillDivision();
      this.DivisionDropDownChanged();
      this.btnshowSave = this.f.status.value != "Completed";
      this.CheckTransactionStatus();
      this.FetchNotesDetails();
      this.FetchPartsDetails();
      this.setTransactionModel({ Id: this.f.Id.value });

      if (this.userDesignation == "Administrator" && this.f.Id.value != "0") {
        this.blnshowDelete = true;
      }
    });
  }

  setDataModel() {
    AppComponent.ShowLoader();
    this.fillDivision();
    this.scrollHelper.scrollToFirst("logo");
    var dmPMID = { Id: this.f.Id.value };

    this.dmapi.GetDMPMDetailsByID(dmPMID).subscribe(
      success => {
        // this.setModel(null);
        this.f.machineName.setValue(success.machineName);
        this.f.PMCode.setValue(success.pmCode);
        this.f.divisionId.setValue(success.divisionId);
        this.selectedDivisionsText = success.divisionName;
        this.f.equipmentId.setValue(success.equipmentId);
        this.selectedEquipmentText = success.equipmentName;
        this.f.scheduledPM.setValue(success.scheduledPM);
        this.f.scheduledPMId.setValue(success.scheduledPMId);
        this.f.PMUser.setValue(success.UserName);
        this.f.type.setValue(success.type);
        this.f.subtype.setValue(success.subtype);

        var tempDateIn = new Date(success.dateIn);

        this.f.dateIn.setValue({
          date: {
            year: tempDateIn.getFullYear(),
            month: tempDateIn.getMonth() + 1,
            day: tempDateIn.getDate()
          },
          jsdate: success.dateIn
        });

        this.f.hoursIn.setValue(success.hoursIn);
        this.f.inHydraulicDisinfection.setValue(
          success.inHydraulicDisinfection
        );
        this.f.inSurfaceDisinfection.setValue(success.inSurfaceDisinfection);

        var tempDateOut = new Date(success.dateOut);
        if (tempDateOut.getFullYear() > 2000) {
          this.f.dateOut.setValue({
            date: {
              year: tempDateOut.getFullYear(),
              month: tempDateOut.getMonth() + 1,
              day: tempDateOut.getDate()
            },
            jsdate: success.dateOut
          });
        }

        this.f.hoursOut.setValue(success.hoursOut);
        this.f.outHydraulicDisinfection.setValue(
          success.outHydraulicDisinfection
        );
        this.f.outSurfaceDisinfection.setValue(success.outSurfaceDisinfection);
        this.f.status.setValue(success.status);
        this.notes.componentDetails.status = success.status;
        this.notes.componentDetails.dateOut = success.dateOut;
        this.f.createdBy.setValue(success.createdBy);
        this.f.createdOn.setValue(success.createdOn);
        this.f.modifiedBy.setValue(success.modifiedBy);
        this.setModel(null);
        // this.setTransactionModel(dmPMID);
      },
      error => {
        AppComponent.addAlert(error.message, "error");
        AppComponent.HideLoader();
      }
    );
  }

  // Transactions Section
  createTransactions(): UntypedFormGroup {
    return new UntypedFormGroup({
      pmId: new UntypedFormControl(0),
      questionId: new UntypedFormControl(""),
      question: new UntypedFormControl(""),
      techId: new UntypedFormControl(0),
      techName: new UntypedFormControl(""),
      value: new UntypedFormControl(""),
      createdBy: new UntypedFormControl(0),
      isLocked: new UntypedFormControl(false),
      order: new UntypedFormControl(0),
      section: new UntypedFormControl(0),
      sectionName: new UntypedFormControl(""),
      imgSrc: new UntypedFormControl(""),
      isValue: new UntypedFormControl(""),
      pin: new UntypedFormControl(""),
      errorMessage: new UntypedFormControl(""),
      errorValueMessage: new UntypedFormControl(""),
      hasNotes: new UntypedFormControl(false),
      hasParts: new UntypedFormControl(false),
      textColor: new UntypedFormControl(""),
      min: new UntypedFormControl(""),
      max: new UntypedFormControl(""),
      dropdownValues: new UntypedFormControl(""),
      createdOn: new UntypedFormControl(""),
      notepartsHTML: new UntypedFormControl(""),
      isSubSection: new UntypedFormControl(false)
    });
  }

  addTransactions(subtype = "") {
    return new Promise((resolve, reject) => {
      this.items = this.preventativeMaintenanceForm.get(
        "transactions"
      ) as UntypedFormArray;


      var pmTypeModel = { type: this.f.type.value, subtype: subtype };

      this.dmapi.GetDMPMQuestionsByType(pmTypeModel).subscribe(
        questionsList => {

          if (questionsList && questionsList.length != this.items.length) {

            while (this.items.length !== 0) {
              this.items.removeAt(0);
            }

            questionsList.sort((a, b) => parseFloat(a.section) - parseFloat(b.section));
            // if (this.f.type.value && this.f.subtype.value) {
            if ((this.f.type.value && this.f.subtype.value) || this.f.Id.value > 0) {
              questionsList.forEach((q, newItemKey) => {
                if ((q.type == this.f.type.value && q.subType == this.f.subtype.value) ||
                  (q.type == '5008' && q.subType == '5008')) {
                  this.items.push(this.createTransactonValue(q.questionId, q.question, q.orderNo, q.section, q.sectionName,
                    q.imgSrc, q.hasValue, q.valUnit, q.min, q.max, q.dropdownValues, q.textColor, q.value, q.isSubSection == true, q.isSubSection));
                }
              });

              if (questionsList.filter(x => x.section === questionsList[0].section).length != questionsList.length || questionsList[0].section) {
                this.showSection = true;
              }
              else {
                this.showSection = false;
              }
            }
          }
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  createTransactonValue(
    questionid,
    question,
    order,
    section,
    sectionName,
    img,
    isvalue,
    valUnit,
    min,
    max,
    dropdownValues,
    textColor,
    defaultValue,
    islocked,
    isSubSection = false
  ): UntypedFormGroup {
    return this.formBuilder.group({
      questionId: questionid,
      question: question,
      order: order,
      section: section,
      sectionName: sectionName,
      imgSrc: img,
      isValue: isvalue ? isvalue : '',
      value: defaultValue ? defaultValue : defaultValue,
      valUnit: valUnit,
      min: min,
      max: max,
      dropdownValues: dropdownValues,
      isLocked: islocked,
      textColor: textColor,
      pmId: 0,
      techId: 0,
      techName: "",
      createdBy: 0,
      pin: "",
      errorMessage: "",
      errorValueMessage: "",
      hasNotes: false,
      hasParts: false,
      createdOn: "",
      notepartsHTML: "",
      isSubSection: isSubSection
    });
  }

  setTransactionModel(dmPMID) {
    AppComponent.ShowLoader();

    setTimeout(() => {
      var fetchtransactions = this.preventativeMaintenanceForm.get(
        "transactions"
      )["controls"];
      this.dmapi.TransactionListByPMID(dmPMID).subscribe(
        success => {
          if (success) {

            if (success.pmTransDetails) {

              fetchtransactions.forEach((transaction, newItemKey) => {
                success.pmTransDetails.forEach((data, newKey) => {
                  if (transaction.controls.questionId.value == data.questionId) {
                    transaction.controls.isLocked.setValue(true);
                    transaction.controls.techId.setValue(data.techId);
                    transaction.controls.techName.setValue(data.techName);
                    transaction.controls.createdOn.setValue(data.createdOn);
                    transaction.controls.pmId.setValue(data.pmId);
                    transaction.controls.value.setValue(data.value);
                  }
                });
                transaction.controls.notepartsHTML.setValue(this.getQuestionsNotePartHTML(transaction.controls.questionId.value, success.pmNotesDetails, success.pmPartsDetails));
              });
            }
          }
          this.CheckTransactionStatus();

          setTimeout(() => {
            AppComponent.loading = false;
            AppComponent.HideLoader();
          });
        },
        error => {
          AppComponent.addAlert(error.message, "error");
          AppComponent.HideLoader();
        }
      );
    });
  }

  getQuestionsNotePartHTML(questionId, notesList, partsList) {
    //
    let qNotes = notesList.filter(x => x.questionId == questionId);
    let qParts = partsList.filter(x => x.questionId == questionId);
    // console.log(qNotes);
    // console.log(qParts);
    return this.getHoverPopupDOM(qNotes, qParts);
    // return this.innerContent;
  }

  getHoverPopupDOM(qNotes, qParts) {
    let data = "";
    if (qNotes || qParts) {
      data += "<div >";
      if (qNotes && qNotes.length > 0) {
        data += "    <div class='box-header noPadding' style='border-bottom: 1px solid black;'>";
        data += "      <h3 class='box-title'><b>Notes</b></h3>";
        data += "    </div>";
        data += "    <div class='box-body noPadding'>";
        data += "      <div >";
        data += "        <div class='col-sm-12 box-row noPadding'>";
        data += "          <div class='col-sm-2 text-center width10'><strong>Date</strong></div>";
        data += "          <div class='col-sm-1 text-center'><strong>User</strong></div>";
        data += "          <div class='col-sm-1 text-center'><strong>Note</strong></div>          ";
        data += "        </div>";
        data += "      </div>";

        qNotes.forEach(item => {
          data += "    <div class='col-sm-12 box-row noPadding'>";
          data += "      <div   class='col-sm-2 text-center width10'>" + new DatePipe('en-US').transform(item.createdOn, 'dd/MM/yyyy') + "</div>";
          data += "       <div   class='col-sm-1 text-center'>" + item.createdByName + "</div>";
          data += "      <div   class='col-sm-9 text-center break-words width81'>" + item.description + "</div>";
          data += "    </div>";
        });

        data += "    </div>";
      }

      if (qParts && qParts.length > 0) {
        data += "  <div class='box-header noPadding' style='border-bottom: 1px solid black;'>";
        data += "    <h3 class='box-title'><b>Replaced Part</b></h3>";
        data += "  </div>";
        data += "  <div class='box-body noPadding'>";
        data += "    <div>";
        data += "      <div class='col-sm-12 box-row noPadding'>";
        data += "        <div class='col-sm-2 text-center width10'><strong>Date</strong></div>";
        data += "        <div class='col-sm-1 text-center'><strong>User</strong></div>";
        data += "        <div class='col-sm-2 text-center'><strong>Part ID</strong></div>";
        data += "        <div class='col-sm-5 text-center width46'><strong>Part Description</strong></div>";
        data += "        <div class='col-sm-1 text-center'><strong>Part Qty.</strong></div>";
        data += "        <div class='col-sm-1 text-center'><strong>Part Cost</strong></div>";
        data += "      </div>";
        data += "    </div>";
        data += "   ";

        qParts.forEach(item => {
          data += "    <div class='col-sm-12 box-row noPadding'>";
          data += "      <div class='col-sm-2 text-center ng-star-inserted width10'>" + new DatePipe('en-US').transform(item.createdOn, 'dd/MM/yyyy') + "</div>";
          data += "      <div class='col-sm-1 text-center'>" + item.createdByName + "</div>";
          data += "      <div class='col-sm-2 text-center'>" + item.partName + "</div>";
          data += "      <div class='col-sm-5 text-left width46 break-words'>" + item.partDescription + "</div>";
          data += "      <div class='col-sm-1 text-center'>" + item.quantity + "</div>";
          data += "      <div class='col-sm-1 text-right'>" + this.currencyPipe.transform(item.totalCost, '$', '$') + "</div>";
          data += "    </div>";
        });
        data += "    </div>";
      }
      data += "</div>";
    }
    return data;
  }

  onPinChange(transactionObj) {

    var transaction = transactionObj.controls;

    if (this.preventativeMaintenanceForm.invalid) {
      AppComponent.addAlert(Globals.FormErrorMessage, "error");
      AppComponent.loading = false;
      this.submitted = true;
      transaction.pin.setValue("");
      this.scrollHelper.scrollToFirst("ng-invalid");
      return;
    }

    if (transaction.isValue.value && transaction.pin.value != "") {
      if (transaction.min.value && transaction.value.value < transaction.min.value) {
        transaction.errorValueMessage.setValue("> " + transaction.min.value + " " + transaction.valUnit.value);
        transactionObj.controls.errorMessage.setValue("");
        transactionObj.controls.value.setValue("");
        transactionObj.controls.pin.setValue("");
      }
      else if (transaction.max.value && transaction.value.value > transaction.max.value) {
        transaction.errorValueMessage.setValue("< " + transaction.max.value + " " + transaction.valUnit.value);
        transactionObj.controls.errorMessage.setValue("");
        transactionObj.controls.value.setValue("");
        transactionObj.controls.pin.setValue("");
      }
      else if (transaction.value.value) {
        this.executeSaveWithTransaction(transactionObj);
      } else {
        transaction.errorValueMessage.setValue("Value Required");
        transactionObj.controls.pin.setValue("");
        transactionObj.controls.errorMessage.setValue("");
      }
    } else if (transaction.pin.value != "") {
      this.executeSaveWithTransaction(transactionObj);
    } else {
      transaction.errorMessage.setValue("");
      transaction.errorValueMessage.setValue("");
    }
  }



  // onPinChange(transactionObj) {
  //
  //   var transaction = transactionObj.controls;

  //   if (this.preventativeMaintenanceForm.invalid) {
  //     AppComponent.addAlert(Globals.FormErrorMessage, "error");
  //     AppComponent.loading = false;
  //     this.submitted = true;
  //     transaction.pin.setValue("");
  //     this.scrollHelper.scrollToFirst("ng-invalid");
  //     return;
  //   }

  //   if (transaction.isValue.value && transaction.pin.value != "") {
  //     if(transaction.min.value && transaction.value.value <  transaction.min.value){
  //       transaction.errorValueMessage.setValue("> " +  transaction.min.value + " " + transaction.valUnit.value);
  //       transactionObj.controls.errorMessage.setValue("");
  //       transactionObj.controls.value.setValue("");
  //     }
  //     else if(transaction.max.value && transaction.value.value > transaction.max.value){
  //       transaction.errorValueMessage.setValue("< " +  transaction.max.value + " " + transaction.valUnit.value);
  //       transactionObj.controls.errorMessage.setValue("");
  //       transactionObj.controls.value.setValue("");
  //     }
  //     else if (transaction.value.value != "") {
  //       this.executeSaveWithTransaction(transactionObj);
  //     } else {
  //       transaction.errorValueMessage.setValue("Value Required");
  //       transactionObj.controls.errorMessage.setValue("");
  //     }
  //   } else if (transaction.pin.value != "") {
  //     this.executeSaveWithTransaction(transactionObj);
  //   } else {
  //     transaction.errorMessage.setValue("");
  //     transaction.errorValueMessage.setValue("");
  //   }
  // }

  executeSaveWithTransaction(transactionObj) {
    AppComponent.ShowLoader();

    transactionObj.controls.techId.setValue(this.currentUserId);
    // var processModel = JSON.stringify(transactionObj.value);
    // this.dmapi.CheckUserPin(processModel).subscribe(
    //   success => {
    // if (success.returnStatus) {
    if (transactionObj.value.pin) {

      transactionObj.controls.errorMessage.setValue("");

      this.CheckPartAddedOnSave(transactionObj).then(
        val => {
          if (this.f.Id.value != 0) {
            this.processTransaction(transactionObj);
          } else {
            this.executeSave(transactionObj);
          }
        },
        err => {
          // console.log(err);

          setTimeout(() => {
            AppComponent.loading = false;
            AppComponent.HideLoader();
          }, 2000);
        }
      );
    } else {
      transactionObj.controls.errorMessage.setValue("");
      transactionObj.controls.errorValueMessage.setValue("");
      transactionObj.controls.pin.setValue("");

      setTimeout(() => {
        AppComponent.loading = false;
        AppComponent.HideLoader();
      }, 2000);
    }

    // },
    // error => {
    //   transactionObj.controls.errorMessage.setValue("Invalid Pin");
    //   transactionObj.controls.errorValueMessage.setValue("");
    //   transactionObj.controls.pin.setValue("");
    // }
    // );


    // AppComponent.HideLoader();
  }

  processTransaction(transactionObj) {

    transactionObj.controls.techId.setValue(this.currentUserId);
    transactionObj.controls.createdBy.setValue(this.currentUserId);
    transactionObj.controls.techName.setValue(this.currentUser);
    transactionObj.controls.pmId.setValue(this.f.Id.value);
    var processModel = JSON.stringify(transactionObj.value);
    AppComponent.ShowLoader();

    this.dmapi.DMPMProcessTransactionDetails(processModel).subscribe(
      success => {
        if (success.returnStatus) {
          transactionObj.controls.isLocked.setValue(true);
          transactionObj.controls.errorMessage.setValue("");
          this.executeSave(transactionObj);

          this.CheckTransactionStatus();
        } else {
          transactionObj.controls.errorMessage.setValue(success.errorMessage);
          transactionObj.controls.pin.setValue("");
          transactionObj.controls.errorValueMessage.setValue(
            success.errorMessage
          );

          setTimeout(() => {
            AppComponent.loading = false;
            AppComponent.HideLoader();
          }, 1000);
        }


        // AppComponent.loading = false;
        // AppComponent.HideLoader();
        // AppComponent.addAlert('Data Saved successfully!', 'success');
      },
      error => {
        transactionObj.controls.errorMessage.setValue(error.message);
        AppComponent.HideLoader();
      }
    );
  }

  CheckTransactionStatus() {
    var trans = this.preventativeMaintenanceForm.get("transactions");
    this.transactionStatus =
      trans.value.filter(obj => obj.isLocked === true).length ==
      trans.value.length;
    // console.log(trans.value.filter((obj) => obj.isLocked === true).length);
    // console.log(this.transactionStatus);
    // return true;
    this.setOutValidations();
  }

  isOpenStatus() {
    return this.f.status.value == "In Progress";
  }
  // Transactions Section

  //PM Main Section

  fillDivision() {
    // this.dmapi.GetDialysisUnitDD().subscribe(list => {
      this.commonapi.FillDivision().subscribe(list => {

      this.DivisionList = list;
      // this.getDivisionDetails();

      if (this.f.Id.value == "0") {
        if (this.detailsType.includes("Home")) {
          this.selectedDivisionObj = this.DivisionList.filter(
            x => x.text === 'Home Program'
          );
          this.f.divisionId.setValue(this.selectedDivisionObj[0].value);
          this.DivisionDropDownChanged();
        }
        else {
          // this.DivisionList = list.filter(
          //   x => x.text != "Home Program"
          // );

          //list.filter(x=> x.text == 'Home Program')[0].text = 'Home Pool';
          this.DivisionList = list;
        }
      }
    });
  }

  getDivisionDetails() {
    if (this.f.divisionId.value != "0") {
      this.selectedDivisionObj = this.DivisionList.filter(
        x => x.value === this.f.divisionId.value.toString()
      );
      this.selectedDivisionsText = this.selectedDivisionObj[0].text;
    }
  }

  getEquipmentDetails() {
    if (this.f.equipmentId.value != "0") {
      this.selectedEquipmentObj = this.Equipments.filter(
        x => x.value === this.f.equipmentId.value.toString()
      );
      this.selectedEquipmentText = this.selectedEquipmentObj[0].text;
    }
  }

  DivisionDropDownChanged() {
    this.fillEquipment(this.f.divisionId.value);

    if (this.f.Id.value == 0) {
      this.f.equipmentId.setValue('');
      this.f.hoursIn.setValue('');
      this.selectedEquipmentHours = 0;
      this.GetScheduledPMHours(this.f.equipmentId.value);
    }
  }



  fillEquipment(divisionID) {
    if (divisionID != 0) {
      this.dmapi.GetEquipmentDD(divisionID).subscribe(list => {
        this.Equipments = list;
        // this.getEquipmentDetails();
      });
    } else {
      this.Equipments = [{ value: "", text: "Select" }];
      this.f.equipmentId.setValue("");
    }

  }

  getSubTypeList(){
    return this.SubTypeList.filter(c=> c.type == this.f.type.value || c.value == '');
  }

  GetScheduledPMHours(equipmentId) {
    this.getEquipmentModelForTypes(equipmentId);

    if (equipmentId != 0) {
      this.f.hoursIn.setValue("");
      var dmPMSchedule = { equipmentId: equipmentId };

      this.dmapi.GetScheduledPMHours(dmPMSchedule).subscribe(result => {
        if (result) {
          this.f.scheduledPM.setValue(result.hours);
          this.f.scheduledPMId.setValue(result.id);
        }
      });

      var eqId = { Id: equipmentId };
      this.dmapi.GetmachaineHistoryMaxHours(eqId).subscribe(result => {
        if (result) {
          this.selectedEquipmentHours = result;
        } else {
          this.selectedEquipmentHours = 0;
        }
      });
    }
  }

  getEquipmentModelForTypes(equipmentId) {
    // AppComponent.ShowLoader();

    this.dmapi
      .GetEquipmentDetailsByID({ Id: equipmentId })
      .subscribe(success => {

        if (success.model && success.model.includes('5008S')) {
          this.f.type.setValue("5008S");
          this.f.subtype.setValue("5008S");
        } else if (success.model && success.model.includes('5008')) {
          this.f.type.setValue("5008");
          this.f.subtype.setValue("5008");
        }
        else if (success.model && success.model.includes('PrismaFlex')) {
          this.f.type.setValue("PrismaFlex");
          this.f.subtype.setValue("PrismaFlex");
        }
        else if (success.model && success.model.includes('2008')) {
          this.f.type.setValue("2008K");
          this.f.subtype.setValue("");
        }
        else if (success.model && success.model.includes('DBB-EXA')) {
          this.f.type.setValue("DBB-EXA");
          this.f.subtype.setValue("");
        }
        else {
          this.f.equipmentId.setValue('');
          this.f.type.setValue("");
          this.f.subtype.setValue("");

          if (success.model)
            AppComponent.addAlert("No PM found for this equipment & Model " + success.model, "error");
        }

        this.setValidators();
        this.addTransactions();

        setTimeout(() => AppComponent.HideLoader(), 1000);
      });
  }

  get f() {
    return this.preventativeMaintenanceForm.controls;
  }

  get dateInText() {
    if (this.f.dateIn.value) {
      //return Globals.GetAPIDate(this.f.dateIn.value.jsdate);
      return Globals.GetAPIDate(this.f.dateIn.value?.jsdate || this.f.dateIn.value?.singleDate?.jsDate);
    }
  }

  get dateOutText() {
    if (this.f.dateOut.value) {
     // return Globals.GetAPIDate(this.f.dateOut.value.jsdate);
      return Globals.GetAPIDate(this.f.dateOut.value?.jsdate || this.f.dateOut.value?.singleDate?.jsDate);
    }
  }

  openImageDialog(transaction): void {
    const dialogRef = this.dialog.open(ImageViewerDialog, {
      position: { right: '0', top: '0' },
      height: '100%',
      width: "620px",
      data: {
        imgURL: transaction.controls.imgSrc.value,
        title: transaction.controls.questionId.value
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Image dialog was closed');
    });
  }

  public myOptions: IAngularMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    closeSelectorOnDateSelect: false,
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1
    }
  };

  setDateOptions() {
    this.myOptions = {
      dateFormat: 'dd/mm/yyyy',
      closeSelectorOnDateSelect: false,
      disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 }
    };
  };

  onDateChanged(event: IMyDateModel): void { }
  //PM Main Section

  //Notes and Parts
  public NoteList = Array<PMNotesModel>();
  ShowParts = true;

  public AddEditNote(transaction, isDisable) {

    this.onMouseOut();
    this.setOutValidations();
    if (!this.CheckFormValidation() || isDisable) return;

    this.notes.componentDetails.API = this.dmapi;
    this.notes.componentDetails.CurrentUserId = this.currentUserId;
    this.notes.componentDetails.CurrentUserName = this.currentUser;
    this.notes.componentDetails.DivisionId = this.f.divisionId.value;
    this.notes.componentDetails.equipmentId = this.f.equipmentId.value;

    this.notes.componentDetails.partscategoryname = this.partscategoryname;
    this.notes.componentDetails.showParts = this.ShowParts;
    this.notes.componentDetails.locked = transaction.controls.isLocked.value;

    //Remove this if condition and else part if need to display N/A Parts on Section Parts/Notes Add Click Button
    if (transaction.controls.questionId.value) {
      if(transaction.controls.value.value == "No")
      {
        this.isAutoPart = false;
      }
      else
      {
        this.isAutoPart = true
      }

       
      this.notes.componentDetails.PrevParts = this.notes.componentDetails.AllParts.filter(
        x => x.questionId == transaction.controls.questionId.value
      );
      this.notes.componentDetails.PrevNotes = this.notes.NoteList.filter(
        x => x.questionId == transaction.controls.questionId.value
      );
    }
    else {
      this.notes.componentDetails.PrevParts = [];
      this.notes.componentDetails.PrevNotes = [];
    }

    this.notes.componentDetails.status = this.f.status.value;

    if (this.notes.componentDetails.PrevParts.length <= 0) {
        if(this.isAutoPart == true)
        {
          var autoParts = this.autoPartsDetails.filter(
            x => x.questionId == transaction.controls.questionId.value
          );
          for (let childObj in autoParts) {
            var pmParts = new PMPartsModel();
            pmParts.equipmentId = autoParts[childObj].equipmentId;
            pmParts.partName = autoParts[childObj].equipmentCode;
            pmParts.partDescription = autoParts[childObj].equipmentDesc;
            pmParts.quantity = autoParts[childObj].quantity.toString();
            pmParts.totalCost = autoParts[childObj].quantity * autoParts[childObj].itemCost;
            pmParts.showPartDelete = false;
            pmParts.pmId = this.f.Id.value;
            pmParts.questionId = transaction.controls.questionId.value;
            pmParts.createdBy = this.currentUserId;
            pmParts.createdByName = this.currentUser;
            pmParts.createdOn = this.today;
          //  pmParts.PartCode =  autoParts[childObj].equipmentCode;
          //  pmParts.PartDescription = autoParts[childObj].equipmentDesc;
          //  pmParts.PartCost =  autoParts[childObj].quantity * autoParts[childObj].itemCost;

            this.notes.componentDetails.PrevParts.push(pmParts);
          }
        }
    }
    this.notes.partsDetails.pmId = this.notes.notesDetails.pmId = this.f.Id.value;
    this.notes.partsDetails.questionId = transaction.controls.questionId.value;
    this.notes.partsDetails.pmId = this.notes.notesDetails.pmId = this.f.Id.value;
    

    // var fetchNoteRecord = this.notes.NoteList.filter(x => x.questionId == transaction.controls.questionId.value)[0];
    // if (fetchNoteRecord && this.notes.componentDetails.locked != true)
    //   this.notes.notesDetails = fetchNoteRecord;
    // else

    this.notes.notesDetails = new PMNotesModel();

    this.notes.notesDetails.createdByName = this.currentUser;
    this.notes.notesDetails.createdBy = this.currentUserId;

    this.notes.notesDetails.questionId = transaction.controls.questionId.value;

    this.notes.AddNote();
  }

  onNoteSave(noteEvent) {
    this.NoteList.push(noteEvent);
  }

  FetchNotesDetails() {
    var dmPMID = { Id: this.f.Id.value };

    this.dmapi.GetPMNotesDetailsbydmPMId(dmPMID).subscribe(
      success => {
        this.notes.NoteList = success;
        AppComponent.loading = false;

        var fetchtransactions = this.preventativeMaintenanceForm.get(
          "transactions"
        )["controls"];
        var preventiveForm = this.f;
        this.notes.NoteList.forEach(function (noteData, newKey) {
          fetchtransactions.forEach(function (transaction, newItemKey) {
            if (transaction.controls.questionId.value == noteData.questionId) {
              transaction.controls.hasNotes.setValue(true);
            }
          });

          // if(new Date(noteData.createdOn) > new Date(preventiveForm.dateOut.value.jsdate) && preventiveForm.status.value == 'Completed')
          //   noteData.isAfterCompletionAdd= true;
        });
      },
      error => {
        AppComponent.addAlert(error.message, "error");
        AppComponent.HideLoader();
      }
    );
  }

  FetchPartsDetails() {
    var pmTypeModel = { type: this.f.type.value, subtype: this.f.subtype.value };

    this.dmapi.GetDMPMAutoPartsByType(pmTypeModel).subscribe(
      parts => {
        var autoParts = this.autoPartsDetails = parts;

        var dmPMID = { Id: this.f.Id.value };
        this.dmapi.GetPMPartsDetailsbydmPMId(dmPMID).subscribe(
          success => {
            var createdById = this.currentUserId;

            this.notes.componentDetails.AllParts = success.filter(function (part) {
              // if (part.createdBy == createdById) {
              //   part.showPartDelete = true;
              // }

              if (
                autoParts &&
                autoParts.some(
                  item =>
                    item.questionId == part.questionId &&
                    item.equiipmentCode == part.partName
                )
              ) {
                part.showPartDelete = false;
                part.isAutoPart = true;
              }

              return part;
            });

            if (this.notes.componentDetails.AllParts && this.parts) {
              this.parts.PartTrans = this.notes.componentDetails.AllParts;
            }

            var fetchtransactions = this.preventativeMaintenanceForm.get(
              "transactions"
            )["controls"];
            var preventiveForm = this.f;
            this.notes.componentDetails.AllParts.forEach(function (
              partData,
              newKey
            ) {
              fetchtransactions.forEach(function (transaction, newItemKey) {
                if (transaction.controls.questionId.value == partData.questionId) {
                  transaction.controls.hasParts.setValue(true);
                }
              });

              // if(new Date(partData.createdOn) > new Date(preventiveForm.dateOut.value.jsdate) && preventiveForm.status.value == 'Completed')
              //   partData.isAfterCompletionAdd= true;
            });

            setTimeout(() => {
              AppComponent.loading = false;
            });
          },
          error => {
            AppComponent.addAlert(error.message, "error");
            AppComponent.HideLoader();
          }
        );


      },
      error => {
        AppComponent.addAlert(error.message, "error");
        AppComponent.HideLoader();
      }
    );

  }

  executeAddNote() { }

  CheckFormValidation() {
    if (this.preventativeMaintenanceForm.invalid) {
      AppComponent.addAlert(Globals.FormErrorMessage, "error");
      AppComponent.loading = false;
      this.submitted = true;
      this.scrollHelper.scrollToFirst("ng-invalid");
      return false;
    } else return true;
  }

  GetParts(partCode) {
    const dmrepairCreate = <any>{};
    const obj = {
      partssearchtext: partCode,
      partscategoryname: this.partscategoryname,
      partsserachtype: "code",
      partsshowinventory: true,
      divisionid: this.f.divisionId.value,
      equipementId: this.f.equipmentId.value
    };

    return this.dmapi.GetPartsdetailsDetailssearchByCategory(obj);
  }

  CheckPartAddedOnSave(transaction) {

    return new Promise((resolve, reject) => {
      var autoParts = this.autoPartsDetails.filter(
        x => x.questionId == transaction.controls.questionId.value
      );
      var autoAdd = false;

      if((transaction.controls.value.value == "Yes" && (transaction.controls.questionId.value =='2.2.0' || transaction.controls.questionId.value =='2.3.0'
      || transaction.controls.questionId.value =='2.4.0')) || !(transaction.controls.questionId.value =='2.2.0' || transaction.controls.questionId.value =='2.3.0'
      || transaction.controls.questionId.value =='2.4.0')) {
        if (this.parts && autoParts.length > 0 && !transaction.controls.hasParts.value) {
          for (let childObj in autoParts) {
            if (
              !this.parts.PartTrans.some(
                item =>
                  item.questionId == transaction.controls.questionId.value &&
                  item.partName == autoParts[childObj].equiipmentCode
              )
            ) {
              autoAdd = true;

              var pmParts = new PMPartsModel();
              pmParts.equipmentId = autoParts[childObj].equipmentId;
              pmParts.partName = autoParts[childObj].equipmentCode;
              pmParts.partDescription = autoParts[childObj].equipmentDesc;
              pmParts.quantity = autoParts[childObj].quantity.toString();
              pmParts.totalCost =
                autoParts[childObj].quantity * autoParts[childObj].itemCost;
              pmParts.showPartDelete = false;
              pmParts.pmId = this.f.Id.value;
              pmParts.questionId = transaction.controls.questionId.value;
              pmParts.createdBy = this.currentUserId;
            //  pmParts.PartCode =  autoParts[childObj].equipmentCode;
            //  pmParts.PartDescription = autoParts[childObj].equipmentDesc;
              //pmParts.PartCost =  autoParts[childObj].quantity * autoParts[childObj].itemCost;

              this.notes.componentDetails.AllParts.push(pmParts);
              resolve("done");
            } else {
              if (parseInt(childObj) == autoParts.length - 1 && !autoAdd)
                resolve("done");
            }
          }
        } else {
          resolve("done");
        }
      }
      else {
        resolve("done");
      }
    });
  }
  //Notes and Parts

  Print() {
    AppComponent.ShowLoader();

    this.dmapi.PrintPreventivePDF({ Id: this.f.Id.value }).subscribe(
      list => {
        AppComponent.HideLoader();
        var openURL = Globals.WorkOrderPFDsUrl + list;
        window.open(openURL);
      },
      error => {
        AppComponent.addAlert(error.message, "error");
        AppComponent.HideLoader();
      }
    );
  }

  getPartCostTotal() {
    let total = 0;
    if (
      this.notes &&
      this.notes.componentDetails &&
      this.notes.componentDetails.AllParts
    ) {
      for (var i = 0; i < this.notes.componentDetails.AllParts.length; i++) {
        if (this.notes.componentDetails.AllParts[i].totalCost) {
          total += this.notes.componentDetails.AllParts[i].totalCost;
        }
      }
    }
    return total;
  }

  GetHasPartsOrNotes(transaction) {
    return (
      transaction.controls.hasNotes.value === true ||
      transaction.controls.hasParts.value === true
    );
  }

  setValidators() {

    if (this.f.type.value == "2008K") {
      this.f.subtype.setValidators([Validators.required]);
    }
    else {
      this.f.subtype.clearValidators();
    }
    this.f.subtype.updateValueAndValidity();


    this.setOutValidations();

    if (this.f.Id.value == 0) {
      this.f.equipmentId.setAsyncValidators([
        DMPMCustomValidators.EquipmentPMStatusValidate(
          this.f.divisionId,
          this.f.Id,
          this.dmapi
        ),
        DMRepairCustomValidators.EquipmentRepairStatusValidate(
          this.f.Id,
          this.dmapi
        )
      ]);
      this.f.equipmentId.updateValueAndValidity();

      this.f.hoursIn.setAsyncValidators([
        DMRepairCustomValidators.EquipmentRepairHoursOutOfPreviousRepair(
          this.f.equipmentId,
          this.f.Id,
          this.dmapi
        )
      ]);
      this.f.hoursIn.updateValueAndValidity();
    }
  }


  setOutValidations(isRequired = false) {
    this.f.hoursOut.clearValidators();
    this.f.dateOut.clearValidators();
    this.f.outHydraulicDisinfection.clearValidators();
    this.f.outSurfaceDisinfection.clearValidators();

    if (this.transactionStatus) {
      // this.f.hoursOut.setValidators([
      //   CommonCustomValidators.CheckHoursoutGreaterHoursInCustomValidation(
      //     this.f.hoursIn
      //   ),Validators.required
      // ]);

      // this.f.dateOut.setValidators([
      //   CommonCustomValidators.CheckDateOutGreaterDateInInCustomValidation(
      //     this.f.dateIn
      //   ),Validators.required
      // ]);

      // this.f.outHydraulicDisinfection.setValidators([Validators.required]);
      // this.f.outSurfaceDisinfection.setValidators([Validators.required]);
      if (isRequired) {
        this.f.hoursOut.setValidators([
          CommonCustomValidators.CheckHoursoutGreaterHoursInCustomValidation(
            this.f.hoursIn
          ), Validators.required
        ]);

        this.f.dateOut.setValidators([
          CommonCustomValidators.CheckDateOutGreaterDateInInCustomValidation(
            this.f.dateIn
          ), Validators.required
        ]);

        this.f.outHydraulicDisinfection.setValidators([Validators.required]);
        this.f.outSurfaceDisinfection.setValidators([Validators.required]);

      } else {
        this.f.hoursOut.clearValidators();
        this.f.dateOut.clearValidators();
        this.f.outHydraulicDisinfection.clearValidators();
        this.f.outSurfaceDisinfection.clearValidators();


        this.f.hoursOut.setValidators([
          CommonCustomValidators.CheckHoursoutGreaterHoursInCustomValidation(
            this.f.hoursIn
          )
        ]);

        this.f.dateOut.setValidators([
          CommonCustomValidators.CheckDateOutGreaterDateInInCustomValidation(
            this.f.dateIn
          )
        ]);
      }
    }
    else {
      this.f.hoursOut.setValidators([
        CommonCustomValidators.CheckHoursoutGreaterHoursInCustomValidation(
          this.f.hoursIn
        )
      ]);

      this.f.dateOut.setValidators([
        CommonCustomValidators.CheckDateOutGreaterDateInInCustomValidation(
          this.f.dateIn
        )
      ]);
    }

    this.f.hoursOut.updateValueAndValidity();
    this.f.dateOut.updateValueAndValidity();
    this.f.outHydraulicDisinfection.updateValueAndValidity();
    this.f.outSurfaceDisinfection.updateValueAndValidity();

  }

  DeleteEvent() {
    this.dialogRef = this.dialog.open(ConfirmationDialog, {
      disableClose: true
    });
    this.dialogRef.componentInstance.confirmMessage =
      "Are you sure you want to delete?";
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        AppComponent.ShowLoader();
        const pmObj = { Id: this.f.Id.value };
        this.dmapi.DeletePMDetailsByID(pmObj).subscribe(
          list => {
            AppComponent.HideLoader();
            AppComponent.addAlert(
              "DM Preventive Maintenance detail deleted successfully!",
              "success"
            );
            this.router.navigate([this.ListURL]);
          },
          error => {
            AppComponent.addAlert(error.message, "error");
            AppComponent.HideLoader();
          }
        );
      }
      this.dialogRef = null;
    });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberOnlywithCondition(event, isMinMax): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      if (isMinMax)
        return false;
      else
        return true;
    }
    return true;
  }


  check4000HoursValidation(): boolean {
    if (this.f.hoursIn.value - this.selectedEquipmentHours >= 4000) {
      return true;
    } else {
      return false;
    }
  }

  stringWithoutDot(str) {
    return str.replace(/\./g, '');
  }

  onMouseHover(transaction) {
    // let code = transaction.controls.questionId.value;
    // let obj = 'lnk' + transaction.controls.questionId.value;

    let code = this.stringWithoutDot(transaction.controls.questionId.value);
    let obj = 'lnk' + this.stringWithoutDot(transaction.controls.questionId.value);


    if (this.GetHasPartsOrNotes(transaction)) {
      this.currentQuestionId = code;
      var menuItem = document.getElementById(obj);
      var top = menuItem.offsetParent['offsetTop'];
      var left = menuItem.offsetParent['offsetLeft'];

      setTimeout(() => {
        if (code == this.currentQuestionId) {
          const popup = document.querySelector("#notepartsPopup" + this.currentQuestionId);
          // this.popleft = -190;
          var elements = document.getElementsByClassName('qustionsList')[0];

          popup.classList.add("show");
          const pop = document.getElementById("notepartsPopup" + this.currentQuestionId);
          // this.poptop = top - ((pop.offsetHeight / 2) + elements.scrollTop) + 12;

          if (menuItem.offsetParent["offsetHeight"] > 40)
            this.poptop = top - ((pop.offsetHeight / 2) + elements.scrollTop) + 12 + (menuItem.offsetParent["offsetHeight"] / 4);
          else
            this.poptop = top - ((pop.offsetHeight / 2) + elements.scrollTop) + 12;

          (document.querySelectorAll('.main-header')[0] as HTMLElement).style.zIndex = '0';
        }
      }, 500);
    }
  }

  onMouseOut() {
    //  var popup = document.querySelector("#notepartsPopup" + this.currentQuestionId);
    var popup = document.querySelector("#notepartsPopup" + this.stringWithoutDot(this.currentQuestionId));
    (document.querySelectorAll('.main-header')[0] as HTMLElement).removeAttribute('style');

    if (popup)
      popup.classList.remove("show");

    this.currentQuestionId = '0';
  }

}
